<template>
  <v-layout
    justify-center
  >
    <v-flex lg12>
      <v-text-field
        outlined
        dense
        :disabled="demandSaved && !canEditDemands"
        v-model="lazyValue"
        @input="onInputChange"
        hide-details
        placeholder="Animais"
        v-only-number
      />
    </v-flex>
  </v-layout>
</template>

<script>
import {mapState} from "vuex"

export default {
  name: "editableCard",
  props: {
    itemQtAnimals: {
      type: String,
      default: "",
    },
    cdPlantaAbate: {
      type: Number,
      default: 0,
    },
    valueField: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState("programacaoAbate", ["demandSaved", "canEditDemands"]),
  },
  data() {
    return {
      lazyValue: this.valueField
    }
  },
  methods: {
    onInputChange(val) {
      this.$emit("input", val)
      this.$emit("changeQtAnimalsList", {
        valueLista: this.itemQtAnimals,
        cdPlanta: this.cdPlantaAbate,
        qtAnimais: parseInt(val),
      })
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .v-text-field__suffix {
  padding-top: 0;
  font-size: 10px;
}
</style>
